import { Component } from '@angular/core';
import { AppSettings } from '../../../app.settings';

@Component({
	selector: 'signout-security-info',
	template: require('./signout-security-info.component.html'),
	host: { class: 'flex-column ' },
})
export class SignoutSecurityInfoComponent {
	public isRebrading = AppSettings.isRebrading;
}
